import { createAsyncThunk } from '@reduxjs/toolkit'

import clientSDK from '../../../../ClientSDK'
import {
  IAPIActivityList,
  IActivity,
  IActivityListError,
} from '../interface/IActivityList'
import { activityListTransformer } from '../transformer/activityListTransformer'

export const fetchActivityList = createAsyncThunk<
  IActivity[],
  undefined,
  { rejectValue: IActivityListError }
>('activityList/fetch', async (payload, { rejectWithValue }) => {
  let apiData: null | IAPIActivityList[] = null
  let offset = 0
  const limit = 200
  let total = 0
  const apiActivities: IAPIActivityList[] = []

  try {
    const promise = clientSDK
      .instance()
      .get<{ data: IAPIActivityList[]; meta: { total: number } }>(
        `activities?page[limit]=${limit}&page[offset]=${offset}`,
      )
    const result = await promise
    total = result.data.meta.total
    apiData = result.data.data
  } catch (error) {
    return rejectWithValue({
      message: 'Could not fetch activity list.',
    })
  }
  do {
    apiActivities.push(...apiData)
    offset += limit
  } while (offset < total)

  return apiActivities.map(activity =>
    activityListTransformer(activity.attributes),
  )
})
